module.exports = __webpack_public_path__ + "media/images/sale_crm/iconmonstr-menu-1-0d95fbdc11dd54266709d97e3a50e40b.svg";